import produce from 'immer';
import { IEventInitialState, types } from './types';

const initialState: IEventInitialState = {
    events: [],
    similarEvents: [],
    eventDetails: null,
    loading: false,
    error: null,
    success: false,
    message: '',
    selectedEvent: undefined,
    fetchingEvent: false,
    updatingEvent: false,
    creatingDiscountCode: false,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_EVENTS:
        case types.GET_EVENT_DETAILS:
        case types.CREATE_EVENT:
        case types.DELETE_EVENT:
        case types.PUBLISH_EVENT:
        case types.UNPUBLISH_EVENT:
        case types.APPROVE_EVENT:
            return produce(state, draft => {
                draft.fetchingEvent = true;
                draft.eventsFilter = undefined;
            });
        case types.UPDATE_EVENT:
            return produce(state, draft => {
                const { feature_image, temp_feature_image } = payload.body || {};
                if (feature_image && temp_feature_image && draft.managedEvent && draft.managedEvent.event) {
                    /** Save the currnt feature image to use when upload fails */
                    draft.managedEvent.event['prev_feature_image'] = draft.managedEvent?.event?.feature_image;
                    draft.managedEvent.event.feature_image = temp_feature_image;
                }
                draft.updatingEvent = true;
                draft.eventsFilter = undefined;
            });
        case types.UPDATE_EVENT_FAIL:
            return produce(state, draft => {
                if (draft.managedEvent && draft.managedEvent.event && draft.managedEvent.event['prev_feature_image']) {
                    draft.managedEvent.event.feature_image = draft.managedEvent.event['prev_feature_image'];
                    draft.managedEvent.event['prev_feature_image'] = undefined;
                }
                draft.updatingEvent = false;
                draft.errMsg = payload;
            });
        case types.FILTER_EVENTS:
        case types.GET_SIMILAR_EVENTS:
            return produce(state, draft => {
                draft.fetchingEvent = true;
            });
        case types.GET_MANAGE_EVENT:
            return produce(state, draft => {
                draft.managedEventLoading = true;
            });
        case types.FILTER_EVENTS_SUCCESS:
        case types.GET_EVENTS_SUCCESS:
            return produce(state, draft => {
                const { data } = payload.data;
                const { totalCount, currentPage, pageSize, results } = payload;
                draft.events = data;
                draft.fetchingEvent = false;
                draft.currentEventLimit = Number(pageSize);
                draft.currentEventPage = Number(currentPage);
                draft.totalResult = totalCount;
                draft.canLoadMore = results >= pageSize;
            });
        case types.GET_EVENT_DETAILS_FAIL:
            return produce(state, draft => {
                draft.fetchingEvent = false;
                draft.errMsg = payload;
                draft.selectedEvent = undefined;
            });
        case types.GET_EVENTS_FAIL:
        case types.CREATE_EVENT_FAIL:
        case types.DELETE_EVENT_FAIL:
        case types.PUBLISH_EVENT_FAIL:
        case types.UNPUBLISH_EVENT_FAIL:
        case types.APPROVE_EVENT_FAIL:
        case types.FILTER_EVENTS_FAIL:
        case types.GET_SIMILAR_EVENTS_FAIL:
            return produce(state, draft => {
                draft.fetchingEvent = false;
                draft.errMsg = payload;
            });
        case types.GET_EVENT_DETAILS_SUCCESS:
        case types.CREATE_EVENT_SUCCESS:
            return produce(state, draft => {
                draft.selectedEvent = payload;
                draft.fetchingEvent = false;
            });
        case types.UPDATE_EVENT_SUCCESS:
            return produce(state, draft => {
                draft.updatingEvent = false;
                if (draft.managedEvent && draft.managedEvent.event) {
                    draft.managedEvent.event.prev_feature_image = undefined;
                    draft.managedEvent.event = payload;
                }
            });
        case types.DELETE_EVENT_SUCCESS:
            return produce(state, draft => {
                draft.fetchingEvent = false;
            });
        case types.PUBLISH_EVENT_SUCCESS:
        case types.UNPUBLISH_EVENT_SUCCESS:
        case types.APPROVE_EVENT_SUCCESS:
            return produce(state, draft => {
                if (draft.selectedEvent) {
                    draft.selectedEvent = { ...draft.selectedEvent, ...payload };
                }
                if (draft.managedEvent && draft.managedEvent.event && draft.managedEvent.event._id === payload._id) {
                    draft.managedEvent.event.status = payload.status;
                }
                draft.fetchingEvent = false;
            });
        case types.GET_SIMILAR_EVENTS_SUCCESS:
            return produce(state, draft => {
                draft.similarEvents = payload;
                draft.fetchingEvent = false;
            });
        case types.SET_EVENT_FILTER:
            return produce(state, draft => {
                draft.eventsFilter = payload;
            });
        case types.GET_MANAGE_EVENT_SUCCESS:
            return produce(state, draft => {
                draft.managedEvent = payload;
                draft.managedEventLoading = false;
            });
        case types.GET_MANAGE_EVENT_FAIL:
            return produce(state, draft => {
                draft.managedEventError = payload;
                draft.managedEventLoading = false;
            });
        case types.CLEAR_MANAGE_EVENT_ERROR:
            return produce(state, draft => {
                draft.managedEventError = null;
            });
        case types.CREATE_DISCOUNT_CODE:
            return produce(state, draft => {
                draft.creatingDiscountCode = true;
            });
        case types.CREATE_DISCOUNT_CODE_SUCCESS:
            return produce(state, draft => {
                draft.creatingDiscountCode = false;
                if (draft.managedEvent && !!payload.event) {
                    draft.managedEvent.event_discounts?.data.push(payload);
                }
            });
        case types.CREATE_DISCOUNT_CODE_FAIL:
            return produce(state, draft => {
                draft.creatingDiscountCode = false;
                draft.errMsg = payload;
            });
        case types.UPDATE_DISCOUNT:
            return produce(state, draft => {
                draft.updatingEvent = true;
            });
        case types.UPDATE_DISCOUNT_SUCCESS:
            return produce(state, draft => {
                if (draft.managedEvent?.event_discounts?.data) {
                    const index = draft.managedEvent.event_discounts.data.findIndex(
                        discount => discount._id === payload._id,
                    );
                    if (index !== -1) {
                        draft.managedEvent.event_discounts.data[index] = payload;
                    }
                }
            });
        case types.UPDATE_DISCOUNT_FAIL:
            return produce(state, draft => {
                draft.updatingEvent = false;
                draft.errMsg = payload;
            });
        case types.DELETE_DISCOUNT:
            return produce(state, draft => {
                draft.updatingEvent = true;
            });
        case types.DELETE_DISCOUNT_SUCCESS:
            return produce(state, draft => {
                if (draft.managedEvent?.event_discounts?.data) {
                    draft.managedEvent.event_discounts.data = draft.managedEvent.event_discounts.data.filter(
                        discount => discount._id !== payload,
                    );
                }
            });
        case types.DELETE_DISCOUNT_FAIL:
            return produce(state, draft => {
                draft.updatingEvent = false;
                draft.errMsg = payload;
            });
        case types.CANCEL_EVENT:
            return produce(state, draft => {
                draft.loading = true;
                draft.error = null;
            });
        case types.CANCEL_EVENT_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
                draft.success = true;
                draft.message = payload.message;
                draft.eventDetails = payload.event;
            });
        case types.CANCEL_EVENT_FAIL:
            return produce(state, draft => {
                draft.loading = false;
                draft.error = payload;
                draft.success = false;
            });
        default:
            return state;
    }
};

export { reducer };
